import React, { useState, useEffect } from 'react';

function AddHouseholdMemberModal({ isOpen, onClose }) {
    const [receiptName, setReceiptName] = useState('');
    const [receiptEmail, setReceiptEmail] = useState('');

    const sendInvite = (e) => {
        e.preventDefault();
        // TODO: Implement invite logic here
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h2>Add Household Member</h2>
                <form onSubmit={sendInvite}>
                    <label>Email:</label>
                    <input
                        type="email"
                        value={receiptEmail}
                        onChange={(e) => setReceiptEmail(e.target.value)}
                        placeholder="Recipient Email"
                        className="email-input"
                    />
                    <div className="modal-buttons">
                        <button type="submit" className="invite-button">
                            Invite
                        </button>
                        <button type="button" onClick={onClose} className="close-button">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddHouseholdMemberModal